import { sendToSentry } from '@utils/sentry';
import { useState } from 'react';

function useLocalStorage<T>(key: string, initialValue: T) {
    const [storedValue, setStoredValue] = useState<T>(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }

        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });

    const setValue = (value: T | ((val: T) => T)) => {
        try {
            const valueToStore =
                value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                if (valueToStore === null) {
                    window.localStorage.removeItem(key);
                    return;
                }
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        } catch (error) {
            sendToSentry('LocalStorageError', 'Failed to set localStorage', {
                error: error,
            });
        }
    };

    return [storedValue, setValue] as const;
}

export { useLocalStorage };
